
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.629 3.073l-4.66 1.864-2.966-.99-2.687-.895a1 1 0 00-.688.02l-5 2C3.249 5.225 3 5.592 3 6v14a1 1 0 001.371.929l4.66-1.864 5.65 1.883h.003a1 1 0 00.688-.02l5-2c.379-.151.628-.52.628-.928V4.002a1 1 0 00-1.371-.93zM9 16.947V5.079l.031-.013L15 7.056v11.868l-.031.013L9 16.947z","fill":"#6b6b6b","fill-rule":"evenodd"}})])
          )
        }
      }
    